var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"src":_vm.$vuetify.theme.dark
          ? require('@/assets/sunny.png')
          : require('@/assets/night.png')}})],1),_c('v-switch',{staticClass:"mt-5",attrs:{"inset":""},on:{"click":_vm.switchMode},model:{value:(_vm.darkMode),callback:function ($$v) {_vm.darkMode=$$v},expression:"darkMode"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }